// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CreateDataGroupRequest,
    CreateDataRequest,
    GatewayError,
    PayloadStagingV1DataGetDataResponse,
    PayloadStagingV1DataGroupGetDataGroupResponse,
    PayloadStagingV1MetaDataGetMetaDataResponse,
    PayloadStagingV1PayloadRetrievePayloadResponse,
    RetrievePayloadRequest,
    StagePayloadRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePayloadStagingApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param systemCode 
     * @param systemId 
     * @param purposeCode 
     * @param purposeId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async dataGetData (systemCode: string, systemId: string, purposeCode: string, purposeId: string, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1DataGetDataResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/Data/GetData/{systemCode}/{systemId}/{purposeCode}/{purposeId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)))
            .replace('{' + 'purposeCode' + '}', encodeURIComponent(String(purposeCode)))
            .replace('{' + 'purposeId' + '}', encodeURIComponent(String(purposeId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling dataGetData.');
        }

        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling dataGetData.');
        }

        // verify required parameter 'purposeCode' is not null or undefined
        if (purposeCode === null || purposeCode === undefined) {
            throw new Error('Required parameter purposeCode was null or undefined when calling dataGetData.');
        }

        // verify required parameter 'purposeId' is not null or undefined
        if (purposeId === null || purposeId === undefined) {
            throw new Error('Required parameter purposeId was null or undefined when calling dataGetData.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1DataGetDataResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGetDataResponse");
        }
        return response;
    }
    /**
     * 
     * @param createDataGroupRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async dataGroupCreateDataGroup (createDataGroupRequest: CreateDataGroupRequest, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1DataGroupGetDataGroupResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/DataGroup/CreateDataGroup';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createDataGroupRequest' is not null or undefined
        if (createDataGroupRequest === null || createDataGroupRequest === undefined) {
            throw new Error('Required parameter createDataGroupRequest was null or undefined when calling dataGroupCreateDataGroup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createDataGroupRequest, "CreateDataGroupRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1DataGroupGetDataGroupResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGroupGetDataGroupResponse");
        }
        return response;
    }
    /**
     * 
     * @param systemCode 
     * @param systemId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async dataGroupGetDataGroup (systemCode: string, systemId: string, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1DataGroupGetDataGroupResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/DataGroup/GetDataGroup/{systemCode}/{systemId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling dataGroupGetDataGroup.');
        }

        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling dataGroupGetDataGroup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1DataGroupGetDataGroupResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGroupGetDataGroupResponse");
        }
        return response;
    }
    /**
     * 
     * @param createDataRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async dataSetData (createDataRequest: CreateDataRequest, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1DataGetDataResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/Data/SetData';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createDataRequest' is not null or undefined
        if (createDataRequest === null || createDataRequest === undefined) {
            throw new Error('Required parameter createDataRequest was null or undefined when calling dataSetData.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createDataRequest, "CreateDataRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1DataGetDataResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGetDataResponse");
        }
        return response;
    }
    /**
     * 
     * @param systemCode 
     * @param systemId 
     * @param purposeCode 
     * @param purposeId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async metaDataGetMetaData (systemCode: string, systemId: string, purposeCode: string, purposeId: string, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1MetaDataGetMetaDataResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/MetaData/GetMetaData/{systemCode}/{systemId}/{purposeCode}/{purposeId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)))
            .replace('{' + 'purposeCode' + '}', encodeURIComponent(String(purposeCode)))
            .replace('{' + 'purposeId' + '}', encodeURIComponent(String(purposeId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling metaDataGetMetaData.');
        }

        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling metaDataGetMetaData.');
        }

        // verify required parameter 'purposeCode' is not null or undefined
        if (purposeCode === null || purposeCode === undefined) {
            throw new Error('Required parameter purposeCode was null or undefined when calling metaDataGetMetaData.');
        }

        // verify required parameter 'purposeId' is not null or undefined
        if (purposeId === null || purposeId === undefined) {
            throw new Error('Required parameter purposeId was null or undefined when calling metaDataGetMetaData.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1MetaDataGetMetaDataResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1MetaDataGetMetaDataResponse");
        }
        return response;
    }
    /**
     * 
     * @param createDataRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async metaDataSetMetaData (createDataRequest: CreateDataRequest, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1MetaDataGetMetaDataResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/MetaData/SetMetaData';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createDataRequest' is not null or undefined
        if (createDataRequest === null || createDataRequest === undefined) {
            throw new Error('Required parameter createDataRequest was null or undefined when calling metaDataSetMetaData.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createDataRequest, "CreateDataRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1MetaDataGetMetaDataResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1MetaDataGetMetaDataResponse");
        }
        return response;
    }
    /**
     * 
     * @param retrievePayloadRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async payloadRetrievePayload (retrievePayloadRequest: RetrievePayloadRequest, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1PayloadRetrievePayloadResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/Payload/RetrievePayload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'retrievePayloadRequest' is not null or undefined
        if (retrievePayloadRequest === null || retrievePayloadRequest === undefined) {
            throw new Error('Required parameter retrievePayloadRequest was null or undefined when calling payloadRetrievePayload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(retrievePayloadRequest, "RetrievePayloadRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1PayloadRetrievePayloadResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1PayloadRetrievePayloadResponse");
        }
        return response;
    }
    /**
     * 
     * @param stagePayloadRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async payloadStagePayload (stagePayloadRequest: StagePayloadRequest, xProgramId?: string): Promise<AxiosResponse<PayloadStagingV1PayloadRetrievePayloadResponse>> {
        const _url_ = '/edge/PayloadStaging/V1/Payload/StagePayload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'stagePayloadRequest' is not null or undefined
        if (stagePayloadRequest === null || stagePayloadRequest === undefined) {
            throw new Error('Required parameter stagePayloadRequest was null or undefined when calling payloadStagePayload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(stagePayloadRequest, "StagePayloadRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PayloadStagingV1PayloadRetrievePayloadResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1PayloadRetrievePayloadResponse");
        }
        return response;
    }
}
